
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><p><strong>Sharpe Ratio</strong> is defined as the risk-adjusted excess return of the index (average
return earned in excess of the risk-free rate per standard deviation). 3-month
US Treasury Bill is chosen as the risk-free rate. The rolling interval determines
the time period used for calculation for each Sharpe Ratio value.</p>
</div>
</template>
